export class ApiError extends Error {
  status: number;
  code?: string;
  fields?: string[];
  body?: any;

  constructor(message: string, status: number, code?: string, body?: any, fields?: string[]) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.fields = fields;
    this.body = body;
  }
}

export function isApiError(error: unknown): error is ApiError {
  if (!error || typeof error !== 'object') return false;
  const candidate = error as Partial<ApiError>;
  return typeof candidate.status === 'number' &&
    (candidate.code === undefined || typeof candidate.code === 'string') &&
    (candidate.fields === undefined ||
      (Array.isArray(candidate.fields) && candidate.fields.every(field => typeof field === 'string')));
}

export async function apiErrorFromResponse(
  response: Response,
  fallback: string,
  localize: (message: string) => string = message => message,
): Promise<ApiError> {
  const body = await response.json().catch(() => ({ error: fallback }));
  const fields = Array.isArray(body?.fields)
    ? body.fields.filter((field: unknown): field is string => typeof field === 'string')
    : undefined;
  return new ApiError(
    localize(body?.error || fallback),
    response.status,
    typeof body?.code === 'string' ? body.code : undefined,
    body,
    fields,
  );
}
